import { useEffect, useMemo } from "react"
import { type FormikValues, useFormikContext } from "formik"
import { getErrorPaths } from "./utils/getErrorPaths"
import { sortElementsByScreenPosition } from "./utils/sortElementsByScreenPosition"

export function FocusFieldError<TFormValues extends FormikValues>() {
    const { errors, isSubmitting, isValidating } = useFormikContext<TFormValues>()

    const fieldElements = useMemo(
        () => getErrorPaths(errors).map((path) => document.getElementsByName(path)[0]),
        [errors]
    )

    const sortedFieldElements = useMemo(
        () => fieldElements.sort(sortElementsByScreenPosition),
        [fieldElements]
    )

    useEffect(() => {
        const fieldElement = sortedFieldElements[0]

        if (fieldElement && isSubmitting && !isValidating) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" })

            // As `focus` hard scrolls to it's element when not visible on the screen,
            // we need to wait for the scroll animation to finish before focusing
            setTimeout(() => fieldElement.focus(), 100)
        }
    }, [isSubmitting, isValidating, sortedFieldElements])

    return null
}
